import PropTypes from 'prop-types';
import postsStrings from 'modules/posts/strings';

import { Wrapper, SearchBarWrapper, SearchBar, SearchBarIcon } from './PostsFilter.style';

const PostsFilter = ({ searchQuery, handleSearchBarInputChange }) => (
  <Wrapper>
    <SearchBarWrapper>
      <SearchBarIcon />
      <SearchBar
        placeholder={postsStrings.postsFilter.searchBarPlaceholder}
        value={searchQuery}
        onChange={handleSearchBarInputChange}
      />
    </SearchBarWrapper>
  </Wrapper>
);
PostsFilter.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
};

export default PostsFilter;
